import React from 'react';
import { ConfidenceProgressBar } from '../index';
import './style.scss';

export const ConfidenceBlock = () => (
  <div className="confidence">
    <h2 className="confidence_subtitle">Confidence</h2>
    <div className="confidence_wrapper">
      <div className="confidence_row">
        <ConfidenceProgressBar percent={65} title="Suite" />
        <ConfidenceProgressBar percent={0} title="Floor" />
        <ConfidenceProgressBar percent={10} title="Address" />
        <ConfidenceProgressBar percent={0} title="ZIP+4" />
      </div>
      <div className="confidence_row">
        <ConfidenceProgressBar percent={65} title="ZIP Code" />
        <ConfidenceProgressBar percent={0} title="Census Block" />
        <ConfidenceProgressBar percent={0} title="Near Net" />
      </div>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/view/screens/Project/components/ConfidenceBlock/index.js